import { Button, Form, Input, Modal, Row, message } from "antd";
import React, { useEffect, useRef, useState } from "react";
import SpinWrapper from "../../../common/Loader/SpinWrapper";
import { axiosInstance } from "../../../controller/axiosInterceptor";
import AddServices from "../add-Services/AddServices";
import AddMoreServices from "./AddmoreServices";

const EditServices = ({ serviceDetails, setPage, hasMore, getServicedData }) => {
  const serviceObj = {
    title: "",
    price: "",
    imgUrl: "",
    description: "",
    subCatId: "",
    subCatName: "",
    preferredSlotDuration: "",
    maximumNumberOfBookings: 0,
  };

  const [showPopup, setShowPopup] = useState(false);
  const [editServices, setEditServices] = useState([]);
  const [categoryValue, setCategoryValue] = useState(null);
  const [services, setServices] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  // const [disabled, setDisabled] = useState(true);
  const [loader, setLoader] = useState(false);
  const [imageLoader, setImageLoader] = useState(false);
  const listInnerRef = useRef();
  const [form] = Form.useForm();

  useEffect(() => {
    getServiceCategory();
  }, []);

  useEffect(() => {
    if (serviceDetails?.length) {
      setCategoryValue(serviceDetails[0].catName);
      getSubCategories(serviceDetails[0].catName, services);
      const currentSelect = serviceDetails?.filter(item => item.catId === serviceDetails[0].catId);
      form.setFieldValue("service_category", serviceDetails[0].catName);
      setEditServices(currentSelect);
      currentSelect.forEach((item, ind) => {
        form.setFieldValue(`service_name_edit-${ind}`, item?.title || "");
        form.setFieldValue(`service_fee_edit-${ind}`, item?.price || "");
        form.setFieldValue(`service_description_edit-${ind}`, item?.description || "");
        form.setFieldValue(`subCategories_edit-${ind}`, item?.subCatName || null);
        form.setFieldValue(`preferredSlotDuration_edit-${ind}`, item?.preferredSlotDuration || 30);
        form.setFieldValue(`maximumNumberOfBookings_edit-${ind}`, item?.maximumNumberOfBookings || 1);
      });
    }
  }, [serviceDetails?.length]);

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      const addedScrollHeight = (scrollTop + clientHeight).toFixed(0);
      if (
        addedScrollHeight == scrollHeight ||
        addedScrollHeight == scrollHeight + 1 ||
        addedScrollHeight == scrollHeight - 1
      ) {
        if (hasMore) setPage(prev => prev + 1);
      }
    }
  };

  const getSubCategories = (value, list) => {
    const service = list.find(item => item.value === value);
    axiosInstance
      .post("/admin/subcategory/list", {
        categoryId: service?.id,
        page: 1,
        pageLimit: 10,
      })
      .then(resp => {
        const modifiedArr = resp.data.output.list.map(i => ({
          value: i._id,
          label: i.name,
        }));
        setSubCategoryList(modifiedArr);
      })
      .catch(console.log);
  };

  const getServiceCategory = () => {
    axiosInstance
      .post("/admin/category/list", { page: 1, pageLimit: 10 })
      .then(res => {
        const modifiedArr = res.data.output.list.map(i => ({
          value: i.name,
          label: i.name,
          id: i._id,
        }));
        setServices(modifiedArr);
        if (serviceDetails) getSubCategories(serviceDetails[0]?.catName, modifiedArr);
      })
      .catch(console.log);
  };

  const handleAddMore = () => {
    setEditServices([...editServices, serviceObj]);
    const index = editServices.length;
    form.setFieldValue(`service_name_edit-${index}`, "");
    form.setFieldValue(`service_fee_edit-${index}`, "");
    form.setFieldValue(`service_description_edit-${index}`, "");
    form.setFieldValue(`subCategories_edit-${index}`, null);
    form.setFieldValue(`preferredSlotDuration_edit-${index}`, "");
    form.setFieldValue(`maximumNumberOfBookings_edit-${index}`, 0);
  };

  const onClickClose = () => setShowPopup(false);
  const handleAddServicesToTopList = () => setShowPopup(true);

  const handleDeleteService = async (id, ind) => {
    if (editServices.length === 1) {
      message.error("Business should have at least one service");
      return;
    }

    if (id) {
      try {
        setLoader(true);
        await axiosInstance.delete(`business/deleteService/${id}`);
        let newList = editServices.filter((_, index) => index !== ind);
        setEditServices(newList.length ? newList : [serviceObj]);
        setLoader(false);
        message.success("Service deleted successfully");
      } catch (error) {
        message.error("Error while deleting service:");
      }
    } else {
      setEditServices(editServices.filter((_, index) => index !== ind));
    }
  };

  const handleSaveChanges = async () => {
    try {
      const list = editServices.map(item => ({
        _id: item._id,
        title: item.title,
        imgUrl: item.imgUrl,
        price: item.price,
        description: item.description,
        subCatId: item.subCatId,
        preferredSlotDuration: item.preferredSlotDuration || 30,
        maximumNumberOfBookings: item.maximumNumberOfBookings || 0,
      }));

      const service = services.find(item => item.value === categoryValue);

      const payload = {
        catId: editServices[0]?.catId || service.id,
        serviceDetails: list,
      };

      await axiosInstance.post("/business/v2/addService", payload);
      message.success("Your services saved successfully");
      getServicedData();
    } catch (error) {
      message.error("Error while saving data:");
    }
  };

  const handleServiceChange = (id, data, ind) => {
    const newList = [...editServices];
    if (id) {
      const itemI = newList.findIndex(it => it._id === id);
      if (itemI >= 0) {
        newList[itemI] = data;
      } else {
        newList[0] = data;
      }
    } else {
      newList[ind] = data;
    }
    setEditServices(newList);
  };

  const handleUpdateServicesArr = (field, value, index) => {
    const updated = [...editServices];
    updated[index] = { ...updated[index], [field]: value };
    setEditServices(updated);
  };

  const disabled = editServices.some(
    item =>
      !item.title ||
      !item.subCatId ||
      !item.price ||
      !item.description || 
      !item.preferredSlotDuration ||
      !item?.imgUrl
  );

  return (
    <SpinWrapper loader={loader || imageLoader}>
      <Form name="editProfile" form={form}>
        <div className="setting-card row overflow-hidden">
          <div className="col-12 common-form-div settings-form-div">
            <h3 className="heading edit-services-heading">Edit Services</h3>
            <Row gutter={16} className="d-flex justify-content-center align-items-center">
              <Form.Item
                className="position-relative w-100"
                label={false}
                name="service_category"
                rules={[{ required: true, message: "Please select your service category!" }]}
              >
                <Input className="category-input" readOnly defaultValue={categoryValue || ""} />
              </Form.Item>
            </Row>
            {editServices?.length > 0 && !loader && (
              <div className="services-list" onScroll={onScroll} ref={listInnerRef}>
                {editServices.map((editService, ind) => (
                  <AddMoreServices
                    edit
                    ind={ind}
                    setLoader={setImageLoader}
                    serviceData={editService}
                    handleServiceChange={handleServiceChange}
                    handleUpdateServicesArr={handleUpdateServicesArr}
                    onDelete={() => handleDeleteService(editService._id, ind)}
                    options={subCategoryList}
                    listInnerRef={listInnerRef}
                    onScroll={onScroll}
                    SHOW_INFO={editServices?.length === ind + 1}
                  />
                ))}
              </div>
            )}
            <div className="add-more-container">
              <Button type="primary" className="add-more-btn" onClick={handleAddMore}>
                Add more
              </Button>
            </div>
          </div>
        </div>
        <div className="btn-container mb-sm-4 mb-xl-0">
          <Button
            type="primary"
            htmlType="submit"
            className="save-button"
            onClick={handleSaveChanges}
            disabled={disabled}
          >
            Save
          </Button>
        </div>
      </Form>

      {showPopup && (
        <Modal
          open={showPopup}
          closable={false}
          onCancel={onClickClose}
          width={820}
          className="common-modal settings-service-modal"
          centered
          footer={null}
        >
          <>
            <div onClick={onClickClose}>
              <img src="/assets/icons/close-icon.svg" alt="close" className="close-icon" />
            </div>
            <AddServices addnewClass from="edit" />
          </>
        </Modal>
      )}
    </SpinWrapper>
  );
};

export default EditServices;
